import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsHireTeam(tenant: Tenant): Faq[] {
	return [
		{
			question: "Kolik pronájem IT týmu stojí?",
			answer:
				"Pronájem specialistů naceňujeme individuálně, nejčastěji podle hodinové sazby za jednoho člověka. Juniorní specialisté stojí od 500 Kč/hodina, seniorní většinou v rozmezí 1 000–2 000 Kč/hodina (nejvíce však 3 000 Kč/hodina).",
		},
		{
			question: "Jak velký IT tým nám můžete pronajmout?",
			answer:
				"Záleží na vašich potřebách. Můžeme vám pronajmout jednoho IT specialistu, ale pro větší projekty třeba i čtyři. Pokud nemáte představu, kolik ajťáků je na daný projekt potřeba, rádi vám poradíme.",
		},
		{
			question: "Kolik hodin měsíčně pro nás vaši specialisté mohou pracovat?",
			answer:
				"Nejčastěji si naši klienti specialisty pronajímají na zhruba 20 hodin týdně. Jednoho odborníka pak propůjčujeme maximálně na 75 % jeho měsíčních kapacit.",
		},
		{
			question: "Jak probíhá fakturace?",
			answer:
				"Platíte jen za skutečně odvedenou práci. Nemusíte se tak obávat fakturace za dny či hodiny, kdy kapacity specialisty/týmu nevyužijete.",
		},
		{
			question: "Můžeme si vybrat mezi seniorním a juniorním IT odborníkem?",
			answer: "Ano, zároveň vám však rádi doporučíme, který specialista je na danou problematiku ideální.",
		},
	];
}
